import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href", "aria-label"]
const _hoisted_2 = { class: "country-item__name" }
const _hoisted_3 = { class: "country-item__container" }
const _hoisted_4 = { class: "country-item__details" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "country-item__temperature-info" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { class: "country-item__price" }
const _hoisted_12 = ["href", "aria-label"]
const _hoisted_13 = { class: "country-item__button-prefix" }

import { addEnabledParams } from '@services/url';
import { pluralize } from '@utils/utils';
import { formatPrice } from '@/js/utils/priceUtils';
import { formatFlightDuration } from '@/js/utils/dateTimeUtils'; // Import the utility function
import { type PackageRegion } from '@/interfaces/api/v1-best-offer-for-region';
import { useStore } from '@/components/common/store';
import { TOTAL_PRICE_TEXT } from '@global-js/constants';
import BasePrice from '@lmt-rpb/Atoms/BasePrice/BasePrice.vue';
import type { SearchFormDataType } from '@interfaces/search-form';
import { computed } from 'vue';

interface Props {
	item: Partial<PackageRegion>;
	currency: string;
	isSummary?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CountryRegionListItem',
  props: {
    item: {},
    currency: { default: 'EUR' },
    isSummary: { type: Boolean, default: false }
  },
  setup(__props: any) {

const store = useStore();



const formData = computed((): SearchFormDataType => store.state.searchMask);
const isHotelOnly = computed((): boolean => formData.value.onlyHotel);

const getDaysDurationLabel = (duration = store.state.searchMask.travelDuration) => {
	let result: string;
	if (duration?.length === 1) {
		result = pluralize(Number(duration[0]), 'Tag', 'Tage');
	} else {
		result = `${duration?.join('-')} Tage`;
	}
	return result;
};

const getTravelersCount = () => {
	const travelers = store.state.searchMask.travelers.adult;
	const children = store.state.searchMask.travelers.children.length;
	return travelers + children + ' Pers.';
};

const temperature = (value: string) => (value !== '-' && `${value}°`) || value;

const getTotalPrice = (item: Partial<PackageRegion>) => {
	const price = item.Pricing?.Total;
	return price?.Converted ?? price?.Amount ?? item.Price ?? 0;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["country-item", { 'is-summary': _ctx.isSummary !== false }]),
    tabindex: "0",
    href: _unref(addEnabledParams)(_ctx.item.URL),
    "aria-label": `Details zu ${_ctx.item.Name} anzeigen`
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.item.Name), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        (_ctx.item.HotelCount)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "country-item__hotel",
              "aria-label": `${_ctx.item.HotelCount} Hotels verfügbar`
            }, _toDisplayString(_ctx.item.HotelCount) + " Hotels ", 9 /* TEXT, PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.item.AirTemperature && _ctx.item.AirTemperature !== '-')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "country-item__air",
                "aria-label": `Lufttemperatur beträgt ${_ctx.item.AirTemperature} Grad`
              }, _toDisplayString(temperature(_ctx.item.AirTemperature)), 9 /* TEXT, PROPS */, _hoisted_7))
            : _createCommentVNode("v-if", true),
          (_ctx.item.WaterTemperature && _ctx.item.WaterTemperature !== '-')
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "country-item__water",
                "aria-label": `Wassertemperatur beträgt ${_ctx.item.WaterTemperature} Grad`
              }, _toDisplayString(temperature(_ctx.item.WaterTemperature)), 9 /* TEXT, PROPS */, _hoisted_8))
            : _createCommentVNode("v-if", true)
        ]),
        (!isHotelOnly.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(['country-item__flight', { 'country-item__flight--hidden': !_ctx.item.FlightDuration }]),
              "aria-label": `Flugdauer beträgt ${_unref(formatFlightDuration)(_ctx.item.FlightDuration)}`
            }, _toDisplayString(_unref(formatFlightDuration)(_ctx.item.FlightDuration)), 11 /* TEXT, CLASS, PROPS */, _hoisted_9))
          : _createCommentVNode("v-if", true)
      ]),
      ((_ctx.item.AirTemperature && _ctx.item.AirTemperature !== '-') || (_ctx.item.FlightDuration && !isHotelOnly.value))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "country-item__user-info",
            "aria-label": `Reisedauer: ${getDaysDurationLabel()}, für ${getTravelersCount()}`
          }, [
            _createTextVNode(_toDisplayString(getDaysDurationLabel()) + " ", 1 /* TEXT */),
            _createElementVNode("span", null, ", " + _toDisplayString(getTravelersCount()), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_10))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", {
        href: _unref(addEnabledParams)(_ctx.item.URL),
        class: "country-item__button",
        "aria-label": `Preis ab ${_unref(formatPrice)(getTotalPrice(_ctx.item), _ctx.currency)}`
      }, [
        _createElementVNode("span", _hoisted_13, [
          _createElementVNode("span", null, _toDisplayString(_unref(TOTAL_PRICE_TEXT)), 1 /* TEXT */)
        ]),
        _createVNode(BasePrice, {
          price: getTotalPrice(_ctx.item)
        }, null, 8 /* PROPS */, ["price"])
      ], 8 /* PROPS */, _hoisted_12)
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})